import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import Skeleton from 'react-loading-skeleton';

import { IDashboardData, IDashboardType, INewsComponent, INewsParams } from 'features/dashboard/interface/dashboard';
import { AddWidgetIcon } from 'shared/icons/icon';
import localizationConstants from 'shared/util/translation/constants';
import { Translate } from 'shared/util/translation/translate';
import FavouriteSortableItem from './favouriteSortableItem';

interface Props {
	data: {
		showLabel: boolean;
		label: string;
		section: string;
		items: IDashboardData[];
		numberOfCards: boolean;
		showAddWidget: boolean;
	};
	news_widget_animation: boolean;
	deleteData: (id: string, isDelete: boolean) => void;
	onSaveNews: (newsId: number, action: boolean, index: number, section: string) => void;
	onSaveTender: (tenderId: number, action: boolean, index: number, section: string, rubrics: string) => void;
	toggleCardView: (elementId: string, view: string) => void;
	onEnd: (evt: Sortable.SortableEvent, sortable: Sortable | null, store: Store) => void;
	costModelUpdateView: (id: number) => void;
	loading: boolean;
}

const FavouriteSortableContainer = (props: Props) => {
	const { news_widget_animation, costModelUpdateView, data, deleteData, onEnd, onSaveNews, onSaveTender, toggleCardView, loading } = props;
	const { items, numberOfCards, section } = data;
	return (
		<ReactSortable
			className={`sortable__wrapper ${section}__wrapper`}
			list={items as any}
			setList={() => false}
			group='shared-group-name'
			multiDrag={false}
			forceFallback
			onEnd={onEnd}
			handle='.dashboard-icon__wrapper'
			sort={true}
			animation={350}
		>
			<>
				{loading &&
					[1, 2, 3, 4, 5].map((_, idx) => (
						<div className='favourite-item__wrapper skeleton-card' key={`skeleton_${idx}`}>
							<div className='card-header__wrapper d-flex justify-content-space-between full-width align-items-center'>
								<div className='header-info__wrapper d-flex align-items-center'>
									<Skeleton className='width--32px height--34px b-radius-top-left-bottom-right' />
									<p className='card-header font--16px ml-10 no-margin cursor-pointer truncate--lines-1 font-weight--600 line-height--22px '>
										<Skeleton className='b-radius--5px width-83px' />
									</p>
								</div>
							</div>
							<Skeleton className='card-items card-items-skeleton' />
						</div>
					))}
				{items.map((data, index) => {
					const key = data.element_id || `${data.name}_${index}`;
					return (
						<FavouriteSortableItem
							value={data}
							key={key}
							cardIndex={index}
							deleteData={deleteData}
							section={section}
							newsLength={(data.type === 'news' && (data as IDashboardType<INewsComponent[], INewsParams>).component_data.length) || 0}
							onSaveNews={onSaveNews}
							onSaveTender={onSaveTender}
							toggleCardView={toggleCardView}
							costModelUpdateView={costModelUpdateView}
							news_widget_animation={news_widget_animation}
						/>
					);
				})}
				{!loading && numberOfCards ? (
					<div
						className={`ignore-elements white-bg favourite-item__wrapper favourite-item__wrapper--${items.length} grid--${items.length} card medium-card d-flex justify-content-center align-items-center`}
					>
						<div className='d-flex justify-content-center align-items-center flex-column'>
							<AddWidgetIcon />
							<h1 className='text-dark-gray font--14px font-weight--500 line-height--20px no-margin'>
								<Translate text={localizationConstants.moveWidgetHere} />
							</h1>
						</div>
					</div>
				) : (
					<></>
				)}
			</>
		</ReactSortable>
	);
};

export default FavouriteSortableContainer;
